export enum NegativeReviewSourceTypeEnum {
    qrCode = 'qr_code',
    qrSet = 'qr_set',
    mailingList = 'mailing_list',
}
